import { IS_MAINNET, GEO_IP_RESTRICTIONS_ENABLED } from '@shared/utils/constant'

const restrictedCountries = new Set(['CA', 'GB'])
const restrictedPerpetualMarketsCountries = new Set([
  'UMI',
  'US',
  'PR',
  'VI',
  'GU',
  'AS',
  'MP'
])

export const isGeoRestrictionEnabled = () => {
  return IS_MAINNET && GEO_IP_RESTRICTIONS_ENABLED
}

const normalizeCountry = (country: string) => country.toUpperCase()

const isGeoRestrictedByApi = (country: string) => {
  const jsonStore = useSharedJsonStore()

  return jsonStore.restrictedCountries
    .map((countryCode) => countryCode.toUpperCase())
    .includes(country)
}

export const isGeoRestricted = (country: string) => {
  if (!isGeoRestrictionEnabled()) {
    return false
  }

  const normalizedCountry = normalizeCountry(country)

  return (
    restrictedCountries.has(normalizedCountry) ||
    isGeoRestrictedByApi(normalizedCountry)
  )
}

export const isDerivativeGeoRestricted = (country: string) => {
  if (!isGeoRestrictionEnabled()) {
    return false
  }

  const normalizedCountry = normalizeCountry(country)

  return (
    isGeoRestricted(normalizedCountry) ||
    restrictedPerpetualMarketsCountries.has(normalizedCountry)
  )
}
